import { useEffect, useState } from 'react';
import { Typography } from '../typography';
import { Button } from '../button';
import { ModalBase, ModalWrapper, ModalFooterButtons } from './ModalComponents';
import { useRepairCreateInvoiceMutation } from '../../hooks';
import { enqueueSnackbar } from '../snackbar';
import { MESSAGES } from '../../const';
import { i18n } from '../../i18n';

interface RepairCreateInvoiceModalType {
  data: {
    id: string;
    number: string;
  }[];
  submitClick: () => void;
  open: () => void;
}

export const repairCreateInvoiceModal: RepairCreateInvoiceModalType = {
  data: [],
  submitClick: () => null,
  open: () => null,
};

export const RepairCreateInvoiceModal = () => {
  const { mutate } = useRepairCreateInvoiceMutation();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    repairCreateInvoiceModal.open = () => {
      setOpen(true);
    };
  }, []);

  const handleOnClose = () => {
    repairCreateInvoiceModal.data = [];
    setOpen(!open);
  };

  const handleSubmitClick = async () => {
    const data = repairCreateInvoiceModal.data.map((item) => ({
      id: item.id,
    }));

    mutate(data, {
      onSuccess: () => {
        setOpen(false);
        enqueueSnackbar(MESSAGES.REPAIR.SUCCESS.INVOICE_CREATED, 'success');
        repairCreateInvoiceModal.submitClick();
      },
      onError: () => {
        enqueueSnackbar(MESSAGES.ERROR_BOUNDARY.DEFAULT, 'error');
      },
    });
  };

  return (
    <ModalBase id={'repair-create-invoice-modal'} open={open} onClose={handleOnClose}>
      <ModalWrapper>
        <Typography variant={'textL'} weight={'bold'}>
          {i18n.t('pages.modal.invoiceCreateTitle')}
        </Typography>
        {repairCreateInvoiceModal.data.map((item, i) => (
          <Typography key={i} variant={'textM'}>
            {item.number}
          </Typography>
        ))}
        <ModalFooterButtons>
          <Button size={'medium'} data-color={'white'} onClick={handleOnClose}>
            {i18n.t('button.cancel')}
          </Button>
          <Button size={'medium'} data-color={'primary'} onClick={handleSubmitClick}>
            {i18n.t('button.submit')}
          </Button>
        </ModalFooterButtons>
      </ModalWrapper>
    </ModalBase>
  );
};
